import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, PaginatedResponse } from '@tcc-mono/shared/data-access';
import { Animal } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransportGroupAnimalService extends BaseService<Animal> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/transport_groups'
  }

  public getAnimals = (transportGroupId: string | number, params?: Params) => {
    return this.getChild(transportGroupId, 'animals', params) as Observable<PaginatedResponse<Animal>>;
  }
}
